// extracted by mini-css-extract-plugin
export default {"hospitals_wrapper":"TpoPolicy_hospitals_wrapper__K+HOn","main_wrapper":"TpoPolicy_main_wrapper__FKPRn"};